import React from 'react'
import Layout from '../components/layout'

const AboutPage = () => {
  return (
    <Layout>
      <main className="py-10">
        <div className="contain">
          <h2 className="heading fz-xl">About page</h2>
        </div>
      </main>
    </Layout>
  )
}

export default AboutPage
